import type { DraftStep } from "@zworks/console-contracts";

/** Renumbers the steps 1..n in their current order. */
export function renumber(steps: DraftStep[]): DraftStep[] {
  return steps.map((step, index) => ({ ...step, position: index + 1 }));
}

/** Moves one step from `from` to `to`, keeping the positions contiguous. */
export function moveStep(steps: DraftStep[], from: number, to: number): DraftStep[] {
  if (from === to || to < 0 || to >= steps.length) return steps;
  const next = [...steps];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved!);
  return renumber(next);
}
